var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M32 15.957C32 7.149 24.87 0 16.084 0 7.298 0 .167 7.149.167 15.957c0 7.723 5.475 14.153 12.733 15.637v-10.85H9.717v-4.787H12.9v-3.99c0-3.08 2.5-5.584 5.571-5.584h3.98v4.787h-3.184c-.875 0-1.592.718-1.592 1.595v3.192h4.775v4.787h-4.775v11.09C25.713 31.034 32 24.237 32 15.956Z",
  fill: "currentColor"
})));
export default SvgFacebook;